import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";

/*
 *  Read More
 *    Script to add a class 'is-open' to a data-read-more container.
 *    Use CSS to style change your state changes.
 *
 *  Version:
 *    1.0.0 - 2021/02/10
 */
var CONTAINER_SELECTOR = '[data-read-more-container]';
var READ_MORE_SELECTOR = '[data-read-more-toggle]';
var CLASS_CONTENT_OPEN = 'is-open';

var readMore = function readMore(container) {
  var readMoreSection = container.querySelectorAll(READ_MORE_SELECTOR);

  function onReadMoreToggle(e) {
    e.preventDefault(), e.stopPropagation();
    container.classList.toggle(CLASS_CONTENT_OPEN);
  }

  readMoreSection.forEach(function (btn) {
    btn.addEventListener('click', onReadMoreToggle);
  });
};

var readMoreContainer = document.querySelectorAll(CONTAINER_SELECTOR);

if (readMoreContainer) {
  readMoreContainer.forEach(function (container) {
    readMore(container);
  });
}